
	export default {
		props: {
		    score: {
		    	type: Object,
		    	required: true
		    },
		    answers: {
		    	type: Object,
		    	default: () => ({})
		    }
		},
		computed: {
			totalMin() {
				let count = 0;

				if (this.answers.questionFirst.includes('AFF')) {
					count += Number(this.score.score_aff.min) || 0;
				} 

				if (this.answers.questionFirst.includes('Chronic Kidney Disease')) {
					count += Number(this.score.score_ckd.min) || 0;
				}

				if (this.answers.questionFirst.includes('ASCVD')) {
					count += Number(this.score.score_ascvd.min) || 0;
				} 

				if (this.answers.questionFirst.includes('HFrEF/HFmrEF') || this.answers.questionFirst.includes('HFpEF')) {
					count += Number(this.score.score_hf.min) || 0;
				}

				return count;
			},
			totalMax() {
			    let count = 0;

				if (this.answers.questionFirst.includes('AFF')) {
					count += Number(this.score.score_aff.max) || 0;
				} 

				if (this.answers.questionFirst.includes('Chronic Kidney Disease')) {
					count += Number(this.score.score_ckd.max) || 0;
				}

				if (this.answers.questionFirst.includes('ASCVD')) {
					count += Number(this.score.score_ascvd.max) || 0;
				} 

				if (this.answers.questionFirst.includes('HFrEF/HFmrEF') || this.answers.questionFirst.includes('HFpEF')) {
					count += Number(this.score.score_hf.max) || 0;
				}

				return count;
			},
			percent() {
				return this.totalMax ? (this.totalMin / this.totalMax) * 100 : 0;
			}
		}
	}
